import { render, staticRenderFns } from "./ReviewsCategoriesHeatmapChart.vue?vue&type=template&id=313f2a3a&scoped=true&"
import script from "./ReviewsCategoriesHeatmapChart.vue?vue&type=script&lang=js&"
export * from "./ReviewsCategoriesHeatmapChart.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsCategoriesHeatmapChart.vue?vue&type=style&index=0&id=313f2a3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313f2a3a",
  null
  
)

export default component.exports